import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Server, Code, Container, Database } from 'lucide-react';
const SERVICES = [
  {
    title: 'Systems & Infrastructure',
    description: 'I handle Linux admin, Nginx/PHP-FPM tuning, and MariaDB/MySQL optimization for peak performance.',
    icon: Server,
    color: 'text-blue-500',
    bg: 'bg-blue-500/10',
    features: ['Linux OS Hardening', 'Nginx/PHP-FPM Tuning', 'MariaDB/MySQL Optimization', 'Bare-metal & Cloud']
  },
  {
    title: 'Cloud Native / K8s',
    description: 'I manage K8s clusters, set up Prometheus monitoring, and implement KEDA for intelligent scaling.',
    icon: Container,
    color: 'text-cyan-500',
    bg: 'bg-cyan-500/10',
    features: ['Kubernetes Management', 'Prometheus Monitoring', 'KEDA Auto-scaling', 'RabbitMQ Queues']
  },
  {
    title: 'Backend Development',
    description: 'I build high-throughput services and APIs using modern PHP and Node.js environments.',
    icon: Code,
    color: 'text-amber-500',
    bg: 'bg-amber-500/10',
    features: ['PHP', 'Node.js', 'API Design', 'Microservices']
  },
  {
    title: 'Data & Analytics',
    description: 'I implement Redis caching and Clickhouse analytics to handle massive data volumes efficiently.',
    icon: Database,
    color: 'text-purple-500',
    bg: 'bg-purple-500/10',
    features: ['Clickhouse Analytics', 'Redis Cache Layers', 'Data Modeling', 'Database Migration']
  }
];
export function Services() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <div className="text-center mb-16 space-y-4">
        <h2 className="text-3xl md:text-5xl font-bold tracking-tight">Personalized IT & Backend Services</h2>
        <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
          Direct technical expertise for your core systems, without the agency overhead.
        </p>
      </div>
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((service) => (
          <div key={service.title}>
            <Card className="h-full border border-border/50 hover:border-primary/50 transition-all duration-300 group">
              <CardHeader>
                <div className={`${service.bg} w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:scale-110`}>
                  <service.icon className={`w-6 h-6 ${service.color}`} />
                </div>
                <CardTitle className="text-xl">{service.title}</CardTitle>
                <CardDescription>{service.description}</CardDescription>
              </CardHeader>
              <CardContent>
                <ul className="space-y-2">
                  {service.features.map(feature => (
                    <li key={feature} className="flex items-center gap-2 text-sm text-muted-foreground">
                      <div className="w-1.5 h-1.5 rounded-full bg-primary/40" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </div>
        ))}
      </div>
    </div>
  );
}